import './new-questionnaire.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateQuestionnaire } from "@core/query/questionnaire.query";
import { QuestionnaireFormRule, QuestionnaireFormSchema } from "@core/form/form.rule";
import { questionnaireFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormQuestionnaire from "../form-questionnaire/form-questionnaire";

export function Questionnaire() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateQuestionnaire } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Questionnaire is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addQuestionnaire, isLoading: isCreating } =
    useQyCreateQuestionnaire(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<QuestionnaireFormSchema>({
    defaultValues: questionnaireFormDefault,
    resolver: zodResolver(QuestionnaireFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: QuestionnaireFormSchema) => {
    const formData = mapCreateQuestionnaire(form);
    addQuestionnaire(formData);
  };
  const handleValidateError = (err: FieldErrors<QuestionnaireFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="Questionnaire" className="questionnaire">
      <HeaderContent
        title="New Questionnaire"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormQuestionnaire />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default Questionnaire;